class CustomFooter extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
      <footer class="footer-wrapper">

        <div class="left-right">
            <div class="footer-left">
                <img class="footer-logo" src="https://hausmesse-kaelterudi.kopfmedia.systems/wp-content/uploads/2025/07/logo-kaelterudi.svg" alt="" > 
                <h2>Erntedank <br>
                    <i>Hausmesse</i>
                </h2>
            </div>

            <div class="footer-right">
                <div class="footer-box">
                    <div class="icon-with-text">
                        <img style="height:20px;" src="https://hausmesse-kaelterudi.kopfmedia.systems/wp-content/uploads/2025/09/calendar.svg">
                        <span>Termin</span>
                    </div>
                    <span>12. Oktober</span>
                    <span>13. Oktober</span>
                    <span>14. Oktober</span>
                     
                </div>
                <div class="footer-box">
                    <div class="icon-with-text">
                        <img style="height:20px;" src="https://hausmesse-kaelterudi.kopfmedia.systems/wp-content/uploads/2025/09/marker.svg">
                        <span>Anfahrt</span>
                    </div>
                    <span>Kälte Rudi GmbH & Co. KG</span>
                    <span>DE-75210 Keltern-Dietlingen</span>
                    <span>Dieselstrasse 5-7 + 15 + 16</span>
                     
                </div>
                <div class="footer-box">
                    <div class="icon-with-text">
                        <img style="height:20px;" src="https://hausmesse-kaelterudi.kopfmedia.systems/wp-content/uploads/2025/09/fi-br-user.svg">
                        <span>Kontakt</span>
                    </div>

                    <a href="https://kaelte-rudi.de" class="footer-link-button icon-with-text">
                        <i class="km-icon-arrow-up-45-deg"></i>
                        <span>kaelte-rudi.de</span>
                    </a>
                    <a href="mailto:info@kaelte-rudi.de" class="footer-link-button icon-with-text">
                        <i class="km-icon-arrow-up-45-deg"></i>
                        <span>info@kaelte-rudi.de</span>
                    </a>
                    <a href="tel:+49 781 257 86" class="footer-link-button icon-with-text">
                        <i class="km-icon-arrow-up-45-deg"></i>
                        <span>+49 781 257 86</span>
                    </a>
                    
                     
                </div>

              
            </div>  
        </div>

        <div class="footer-bottom-line">
             <p class="footer-watermark">&copy; ${new Date().getFullYear()} Kälte Rudi GmbH</p>
             <div class="footer-link-container">
                
                <a href="" class="footer-link-button icon-with-text">
                    <i class="km-icon-arrow-up-45-deg"></i>
                    <span>Impressum</span>
                </a>

                <a href="" class="footer-link-button icon-with-text">
                    <i class="km-icon-arrow-up-45-deg"></i>
                    <span>Datenschutz</span>
                </a>

                <a href="" class="footer-link-button icon-with-text">
                    <i class="km-icon-instagram"></i>
                    <span>Instagram</span>
                </a>

             </div>
        </div>
     
      </footer>
    `;
    }
}

customElements.define('custom-footer', CustomFooter);
